import React, { useEffect } from 'react';
import FacilityPage from '../components/FacilityPage';

export const BarAndLounge: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Bar & Lounge"
      description="Our bar and lounge combines the best of both worlds - a sophisticated bar with premium spirits and a comfortable lounge area perfect for relaxation and socializing."
      features={["Premium spirits and cocktails", "Comfortable lounge seating", "Professional bartenders", "Happy hour specials"]}
      images={["/images/facilities/bar-and-lounge.jpg"]}
    />
  );
};

export const Pub: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Pub"
      description="Experience the classic pub atmosphere with great food, drinks, and entertainment. Our pub offers a casual dining experience with a wide selection of beers and comfort food."
      features={["Wide selection of beers", "Comfort food menu", "Sports viewing", "Casual atmosphere"]}
      images={["/images/facilities/pub.jpg"]}
    />
  );
};

export const Hangout: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Hangout"
      description="The perfect place to hang out with friends and family. Our hangout area provides a relaxed environment where you can unwind and enjoy good food and drinks."
      features={["Relaxed atmosphere", "Group-friendly seating", "Casual dining", "Perfect for friends"]}
      images={["/images/facilities/hangout.jpg"]}
    />
  );
};

export const CorporateParty: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Corporate Party"
      description="Parties are often to celebrate a milestone, show appreciation for hard work, or build relationships. Our corporate party services ensure your business celebrations are memorable and professional."
      features={["Professional event planning", "Customizable packages", "Team building activities", "Catering services"]}
      images={["/images/facilities/restro.jpg"]}
    />
  );
};

export const BirthdayParty: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Birthday Party"
      description="Make your birthday celebration unforgettable with our special birthday party packages. We provide everything you need for a perfect birthday celebration."
      features={["Birthday decorations", "Special birthday menu", "Cake arrangements", "Party entertainment"]}
      images={["/images/about1.jpg"]}
    />
  );
};

export const CelebrityAppearance: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Celebrity Appearance"
      description="Host exclusive celebrity appearance events at our venue. We provide the perfect setting and professional event management for celebrity events and meet-and-greets."
      features={["VIP arrangements", "Security management", "Media coordination", "Exclusive venue access"]}
      images={["/images/facilities/celebrity -appearance.jpg"]}
    />
  );
};

export const NightLife: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Night Life"
      description="Experience the vibrant nightlife at Bangtan Lounge. With exciting music, premium drinks, and an electric atmosphere, we offer the best nightlife experience in Mira Road."
      features={["Late night entertainment", "DJ music", "Premium cocktails", "Vibrant atmosphere"]}
      images={["/images/facilities/night-life.jpg"]}
    />
  );
};

export const CorporateBusinessLounge: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Corporate Business Lounge"
      description="Our corporate business lounge provides a professional environment for business meetings, networking events, and corporate gatherings with all modern amenities."
      features={["Business meeting facilities", "High-speed internet", "Professional atmosphere", "Catering services"]}
      images={["/images/facilities/restro.jpg"]}
    />
  );
};